const normalizeExtension = (extension = '') => {
  if (!extension) {
    return '';
  }

  return extension.startsWith('.') ? extension : `.${extension}`;
};

export const getAttachmentNameWithExtension = (attachment = {}) => {
  const { name = '', extension = '' } = attachment || {};

  if (!name) {
    return '';
  }

  const normalizedExtension = normalizeExtension(extension);

  if (!normalizedExtension) {
    return name;
  }

  return name.toLowerCase().endsWith(normalizedExtension.toLowerCase())
    ? name
    : `${name}${normalizedExtension}`;
};
